


































import { Component, Vue, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { WorkordersApi } from 'performo-api';
import { mapGetters } from 'vuex';
import { User } from 'oidc-client';

@Component({
  components: { EditOnClickField },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    ordersApi: 'ordersApi'
  })
})
export default class DescriptionEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: 'Work Description' })
  private label!: string;

  @Prop({ required: true, default: '' })
  private value!: string | number | undefined;

  private descriptionMode = 'read';

  private currentPropertyId!: string;
  private currentUser!: User;

  private loading!: boolean;

  private ordersApi!: WorkordersApi;

  data() {
    return {
      loading: false
    };
  }

  private async mounted() {
    // blank
  }

  private async inputFocused(textArea: HTMLTextAreaElement) {
    if (!textArea) {
      textArea = this.$refs.descriptionTextArea as HTMLTextAreaElement;
    }

    // focus the input and set the cursor to the beginning of the element.
    textArea.setSelectionRange(0, 0);
    textArea.focus();
  }

  private async handleDescriptionChange(description: string) {
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === description) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeDescription({
        workorderId: this.workorderId,
        changeOrderDescriptionCommand: {
          newDescription: description
        }
      });
      // emit changed event
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    // exit
    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.descriptionMode = 'read';
    this.loading = false;
  }
}
